import Alert from "@components/alert";
import styled from "styled-components";

import { SmartHeaderStyled } from "../../views/formView/FormView.styles";
import { VIEW_PADDING_VALUE } from "../../views/View.styles";

export const ChatsFormViewStyled = styled.div`
    position: relative;
    padding: ${VIEW_PADDING_VALUE}px 0;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    height: 100%;
    overflow-x: auto;
`;

export const SmartHeaderTicketsStyled = styled(SmartHeaderStyled)`
    padding: 0 ${VIEW_PADDING_VALUE}px;
`;

export const HandoverAlert = styled(Alert) `
    margin-bottom: 20px;
`;

export const ChatAlertArea = styled.div `
    margin-left: 30px;
    margin-right: 46px; 
`;

export const ChatBcWrapper  = styled.div `
    margin-bottom: 17px;
`;